export default __webpack_public_path__ + "static/media/giftbox-error.b60dadda.svg";